exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrap[data-v-6c4a1a1b] {\n  max-width: 600px;\n  font-size: 18px;\n}\n.wrap .message[data-v-6c4a1a1b] {\n    padding-right: 6px;\n}\n.wait-text[data-v-6c4a1a1b] {\n  font-weight: bold;\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c4a1a1b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/timer/Timer.vue
// module id = vF1B
// module chunks = 1